import Typography from '@invotra/invotra-mdc/lib/widgets/Typography'
import React from 'react'

export default function Pages() {
  return (
    <Typography use="headline2">Pages</Typography>
  )
}
